import { Product } from '../../../modules/product/models/Product'
import { useEffect, useState } from 'react'
import { useStyles } from '../Application.styles'
import { COLOR_PRIMARY } from '../../../routes/color-constants'
import { useTranslation } from 'react-i18next'
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  CircularProgress,
} from '@mui/material'
import { getSampleTypeContainer } from '../../../container/sampleType-modules'
import { SampleTypeService } from '../../../modules/sampleType/services/SampleTypeService'
import { SAMPLETYPE_SERVICE_KEY } from '../../../modules/sampleType'
import { Query } from '../../../common/api/Query'
import { SampleType } from '../../../modules/sampleType/models/SampleType'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2'
import { PatientPGTDTO } from '../../../modules/patient/models/patientForm/PatientPGTDTO'
import { PatientProduct } from 'modules/patient/models/relationship/PatientProduct'
import { emptySamplePGTDTO } from 'modules/sampleType/models/sampleForm/SamplePGTDTO'
import { format, isValid } from 'date-fns'
import {convertTimeToLocal, formatDate } from '../../../common/utils/DataFormatters'

type RouteProps = {
  id?: string
  navigate?: () => void
}

export type SamplePGTProps = RouteProps & {
  patients: PatientPGTDTO[]
  patientProduct: PatientProduct
  product: Product
  handleChangePatientProducts: (pp: PatientProduct, i: number) => void
  index: number
  edit?: boolean
}

const sampleTypeService = getSampleTypeContainer().get<SampleTypeService>(SAMPLETYPE_SERVICE_KEY)

export const SamplePGT = (props: SamplePGTProps) => {
  const [patientNumber, setPatientNumber] = useState<number>(props.product.patientNumber || 0)
  const classes = useStyles({ color: COLOR_PRIMARY })
  const { t, i18n } = useTranslation()
  const [sampleType, setSampleType] = useState<SampleType[]>([])
  const [patientProduct, setPatientProduct] = useState<PatientProduct>(props.patientProduct)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    //get types of samples from DDBB
    sampleTypeService.getFilteredListDB(new Query({})).subscribe((res) => {
      setSampleType(res.items)
      setIsLoading(false)
    })
  }, [])

  const handleChangePatients = (e: any, type: string, index: number) => {
    if (props.patients) {
      let p = props.patients[index]
      let pp = props.patientProduct

      if (p && p._sample) {
        if (type == '_typeSample') {
          p._sample._typeSample = e.target.value
          p._sample.typeSample = e.target.value
        } else if (type == '_codeSample') {
          p._sample._codeSample = e.target.value
          p._sample.codeSample = e.target.value
        } else if (type == 'language') {
          pp.language = e.target.value
          pp._language = e.target.value
        }

        let patients = props.patients
        patients[index] = p

        //@ts-ignore
        let newProduct = Object.assign({ ...patientProduct }, { patientPGTs: patients })
        //@ts-ignore
        setPatientProduct(newProduct)
        //@ts-ignore
        props.handleChangePatientProducts(newProduct, props.index)
      } else {
        let p = props.patientProduct.patientPGTs[index]
        if (p && p._sample) {
          if (type == '_typeSample') {
            p._sample._typeSample = e.target.value
            p._sample.typeSample = e.target.value
          } else if (type == '_codeSample') {
            p._sample._codeSample = e.target.value
            p._sample.codeSample = e.target.value
          } else if (type == 'language') {
            pp.language = e.target.value
            pp._language = e.target.value
          }

          let patients = props.patients
          patients[index] = p

          //@ts-ignore
          let newProduct = Object.assign({ ...patientProduct }, { patientPGTs: patients })
          //@ts-ignore
          setPatientProduct(newProduct)
          //@ts-ignore
          props.handleChangePatientProducts(newProduct, props.index)
        }
      }
    }
  }

  const handleChangePatientsDate = (d: Date, index: number) => {
    if (props.patients) {
      let p = props.patients[index]

      if (!p._sample) {
        //@ts-ignore
        p._sample = emptySamplePGTDTO()
      }

      p._sample._extractionDate = d

      let patients = props.patients
      patients[index] = p

      //@ts-ignore
      let newProduct = Object.assign({ ...patientProduct }, { patientPGTs: patients })
      //@ts-ignore
      props.handleChangePatientProducts(newProduct, props.index)
      //@ts-ignore
      setPatientProduct(newProduct)
    }
  }


  return (
    <>
      {!isLoading ? (
        <Grid container direction="column">
          {[...Array(patientNumber)].map((_, index) => (
            <Grid container spacing={4} key={index} style={{ marginTop: '40px' }}>
              <Grid
                item
                xs={12}
                style={{ textAlign: 'left', fontWeight: 'bold', fontSize: '18px' }}>
                {t('dateAboutSample') + ' ' + (index + 1) + ' ' + t('for') + ' ' + (i18n.language ==
                'es'
                  ? props.product?.nameES
                  : props.product?.nameEN)}
              </Grid>
              <Grid item xs={12}>
                <FormControl variant="filled" fullWidth>
                  <InputLabel id="typeSampleLabel">{t('typeSample') + '*'}</InputLabel>
                  <Select
                    labelId={'typeSampleLabel'}
                    id={'type'}
                    name={'type'}
                    disabled={props.edit == false}
                    onChange={(e) => handleChangePatients(e, '_typeSample', index)}
                    value={patientProduct.patientPGTs[index]?._sample?._typeSample}>
                    {sampleType.map((elementST, indexST) => {
                      return (
                        <MenuItem key={indexST} value={elementST.idOdoo ? elementST.idOdoo : ''}>
                          {(i18n.language == 'es' ? elementST?.nameES : elementST?.nameEN)}
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={`code-${index}`}
                  label={t('codeSample')}
                  disabled={props.edit == false}
                  variant="filled"
                  className={classes.textField}
                  fullWidth
                  value={patientProduct.patientPGTs[index]?._sample?._codeSample}
                  onChange={(e) => handleChangePatients(e, '_codeSample', index)}
                />
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    format="dd/MM/yyyy"
                    onChange={(date) => date && isValid(date) && handleChangePatientsDate(formatDate(date), index)}
                    value={convertTimeToLocal(patientProduct.patientPGTs[index]?._sample?._extractionDate )|| null}
                    label={t('doe')}
                    disabled={props.edit == false}
                    slotProps={{
                      textField: {
                        variant: 'outlined',
                        size: 'small',
                        required: true,
                        sx: { width: '100%' },
                        id: `dob-${index}`,
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          ))}
        </Grid>
      ) : (
        <CircularProgress style={{ alignSelf: 'center' }} />
      )}
    </>
  )
}
